export const isCertva = typeof window !== 'undefined' && window.location.hostname === 'www.certva.com';

export function resolvePoKName() {
    return isCertva ? 'CERTVA' : 'POK';
}

export const pokLogo = isCertva ? '_certva_logo.png' : '_POK_Logo_primary.webp';
export const pokLogoDark = () => (isCertva ? 'blog_certva_logo.png' : 'pok_navbar_logo.webp');

export function resolvePoKDomain() {
    return isCertva ? 'certva.com' : 'pok.tech';
}
